import type { ValuesOf } from '@do/utils/types';

export const LabelVariant = {
  Rounded: 'rounded',
  Square: 'square',
} as const;
export type LabelVariant = ValuesOf<typeof LabelVariant>;
